import script from "./AttachmentImage.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentImage.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentImage.vue?vue&type=style&index=0&id=f3ab26e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ab26e4"]])

export default __exports__